import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Revision, RevisionStatus } from 'Definitions/Revision.type.ts'

import { dispatchGetPurchaseRevision } from 'Api/admin/admin.revision.service.ts'

interface InitialStateProps {
  purchaseRevisionList: Revision[]
  loading: boolean
  pageSize: number
  total: number
  param: string
  minDate: Date | null
  maxDate: Date | null
  status: RevisionStatus
  order: 'ASC' | 'DESC'
}

const initialState: InitialStateProps = {
  purchaseRevisionList: [],
  loading: false,
  pageSize: 20,
  total: 0,
  param: '',
  maxDate: null,
  minDate: null,
  status: 'ALL',
  order: 'ASC',
}

export const purchaseRevisionSlice = createSlice({
  name: 'purchaseRevision',
  initialState,
  reducers: {
    setParam: (state, action) => {
      state.param = action.payload
    },
    setMinDate: (state, action: PayloadAction<Date>) => {
      if (action.payload) {
        state.minDate = action.payload
      }
    },
    setMaxDate: (state, action: PayloadAction<Date>) => {
      if (action.payload) {
        state.maxDate = action.payload
      }
    },
    setStatus: (state, action: PayloadAction<RevisionStatus>) => {
      if (action.payload) {
        state.status = action.payload
      }
    },
    setOrder: (state, action: PayloadAction<'ASC' | 'DESC'>) => {
      if (action.payload) {
        state.order = action.payload
      }
    },
    resetRevision: (state) => {
      state.purchaseRevisionList = []
      state.total = 0
      state.loading = false
      state.param = ''
      state.minDate = null
      state.maxDate = null
      state.status = 'ALL'
      state.order = 'ASC'
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(dispatchGetPurchaseRevision.fulfilled, (state, action) => {
        if (action.payload) {
          state.purchaseRevisionList = action.payload.revisionList
          state.total = action.payload.total
          state.loading = false
        }
      })
      .addCase(dispatchGetPurchaseRevision.pending, (state) => {
        state.loading = true
      })
      .addCase(dispatchGetPurchaseRevision.rejected, (state) => {
        state.loading = false
      })
  },
})

export const {
  setParam, setMinDate, setMaxDate, setStatus, resetRevision, setOrder,
} = purchaseRevisionSlice.actions
export default purchaseRevisionSlice.reducer
